<template>
  <header class="bg-dark-light py-3 px-6 flex justify-between items-center datav-border">
    <div class="flex items-center gap-3">
      <i class="fa fa-line-chart text-primary text-2xl"></i>
      <h1 class="text-xl font-bold">雪峰山电视调频发射台</h1>
    </div>
    <div class="flex items-center gap-6">
      <div class="flex items-center gap-2">
        <i class="fa fa-clock-o text-text-secondary"></i>
        <span id="current-time" class="text-text-secondary"></span>
      </div>
      <div class="flex items-center gap-2">
        <button @click="handleToggleFullScreen" class="p-2 hover:bg-primary/20 rounded transition">
          <i :class="isFullScreen ? 'fa fa-compress' : 'fa fa-expand'" class="text-text-secondary"></i>
        </button>
      </div>
      <div class="flex items-center gap-2">
        <i class="fa fa-user-circle-o text-text-secondary"></i>
        <span class="text-text-secondary">管理员</span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    isFullScreen: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    this.updateTime();
    setInterval(this.updateTime, 1000);
  },
  methods: {
    updateTime() {
      const now = new Date();
      const timeString = now.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
      document.getElementById('current-time').textContent = timeString;
    },
    handleToggleFullScreen() {
      this.$emit('toggle-full-screen');
    }
  }
};
</script>

<style lang="scss" scoped>
</style>